module.exports = __webpack_public_path__ + "static/img/vlogPreview.f194e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/vlogPreview.png
// module id = 3r/S
// module chunks = 1